import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";

export const GetEvents =
  ({ callback, page, rowsPerPage, search }) =>
  async (dispatch, getState) => {
    try {
      const query = search
        ? `?search=${search}&limit=${1000}&page=${0}`
        : `?page=${page}&limit=${rowsPerPage}`;
      let link = UrlApi.events.get + query;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteEvent =
  ({ eventId, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.events.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${eventId}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageEvents =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      let startDateAsString = values?.start_date?.toString();
      let endDateAsString = values?.end_date?.toString();
      console.log({ values_manageEvents: values });
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      let paramID = "";
      if (editMode) {
        paramID = values?.id;
      }
      if (CheckDataIfExit(values?.title)) {
        bodyFormData.append("title", values?.title?.trim());
      }
      if (CheckDataIfExit(values?.location)) {
        bodyFormData.append("location", values?.location?.trim());
      }
      if (CheckDataIfExit(values?.end_date)) {
        bodyFormData.append("end_date", endDateAsString);
      }
      if (CheckDataIfExit(values?.start_date)) {
        bodyFormData.append("start_date", startDateAsString);
      }
      if (CheckDataIfExit(values?.video_link)) {
        bodyFormData.append("video_link", values?.video_link?.trim());
      }
      if (CheckDataIfExit(values?.file_download)) {
        bodyFormData.append("file_download", values?.file_download?.trim());
      }
      if (CheckDataIfExit(values?.map_embedded)) {
        bodyFormData.append("map_embedded", values?.map_embedded?.trim());
      }
      if (CheckDataIfExit(values?.full_description)) {
        bodyFormData.append(
          "full_description",
          values?.full_description?.trim()
        );
      }
      if (CheckDataIfExit(values?.map_embed)) {
        bodyFormData.append("map_embed", values?.map_embed);
      }
      if (values?.image != null && values?.image != undefined) {
        if (CheckImageIsFile({ data: values?.image, IsBoolean: true })) {
          // New file selected
          bodyFormData.append("image", values?.image);
        } else if (editMode && typeof values?.image === "string") {
          // Existing image kept as string
          bodyFormData.append("image", values?.image);
        } else if (editMode && values?.image === "") {
          // Explicitly cleared
          bodyFormData.append("image", "");
        }
      } else if (editMode && !values?.image) {
        bodyFormData.append("remove_image", "1");
        bodyFormData.append("image", "");
      }
      if (
        values?.video &&
        values?.video != null &&
        values?.video != undefined &&
        CheckImageIsFile({ data: values?.video, IsBoolean: true })
      ) {
        bodyFormData.append("video", values?.video);
      } else if (editMode && !values?.video) {
        bodyFormData.append("remove_video", "1");
        bodyFormData.append("video", "");
      }
      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode
          ? `${UrlApi.events.edit}/${paramID}`
          : UrlApi.events.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.log({ kjandgadsg___: err });
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditEvents =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.events.edit + `/${id}`,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

// export const EditFaqs =
//   ({ callback, allData, FaqsId, nameFailed, dataFailed }) =>
//   async (dispatch, getState) => {
//     try {
//       dispatch(setLoading(true));
//       let data;
//       if (allData) {
//         data = allData;
//       } else {
//         data = {
//           id: FaqsId,
//           [nameFailed]: dataFailed,
//         };
//       }
//       const response = await PostFunction({
//         data,
//         Route: UrlApi.faqs.edit,
//         showalert: true,
//         state: getState,
//         isMultipart: false,
//         dispatch: dispatch,
//       });
//       dispatch(setLoading(false));
//       callback(response);
//     } catch (err) {
//       dispatch(setLoading(false));
//       callback(false);
//     }
//   };

// export const DeleteFaqs =
//   ({ callback, id }) =>
//   async (dispatch, getState) => {
//     try {
//       dispatch(setLoading(true));
//       let data = {
//         idsfaqs: JSON.stringify(id),
//       };
//       const response = await PostFunction({
//         data,
//         Route: UrlApi.faqs.delete,
//         showalert: true,
//         state: getState,
//         isMultipart: false,
//         dispatch: dispatch,
//       });
//       dispatch(setLoading(false));
//       callback(response);
//     } catch (err) {
//       dispatch(setLoading(false));
//       callback(false);
//     }
//   };
